const AWS = require('aws-sdk');

// const wasabiEndpoint = new AWS.Endpoint('s3.ap-northeast-1.wasabisys.com');

const wasabiEndpoint = new AWS.Endpoint(process.env.REACT_APP_S3_URL)
const ENDPOINT_URL_IMAGE = `${process.env.REACT_APP_S3_URL}/admin-order/`
var S3 = require('aws-sdk/clients/s3');
const upload = new S3({
    endpoint: wasabiEndpoint,
    region: process.env.REACT_APP_REGION,
    accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
})

export const getSignedUrl = async (file) => {
    try {


        if (!file) return ''
        if (!file.startsWith('https://' + ENDPOINT_URL_IMAGE, '')) return file;
        // Generate presigned URL
        var key = file.replaceAll('https://' + ENDPOINT_URL_IMAGE, '');

        // Generate presigned URL
        // var key = file.replaceAll(ENDPOINT_URL_IMAGE, '');
        const params = {
            Bucket: process.env.REACT_APP_BUCKET_NAME,
            Key: key,
            Expires: 3600 // URL expires in 1 hour (adjust as needed)
        };

        var url = await upload.getSignedUrlPromise('getObject', params);


        return url;
    } catch (error) {
        console.log(error)
        return ''
    }
}

// module.exports = {
//     getSignedUrl,
// };